import DMS from "./DMS";
import RSU from "./RSU";
import ESS from "./ESS";
import Verification from "./Verification";
import PERMISSIONS from "@/common/permissions-lib";

import PageViewer from "@/components/PageViewer";

import { isNil } from "lodash";
import store from "@/store";
import DeviceManagerStoreModule from "@/store/modules/device-manager";

const checkContextMenuLatLng = (to, from, next) => {
	const contextMenuLatLng =
		store.getters[DeviceManagerStoreModule.MODULE_NAME + "/contextMenuLatLng"];
	if (
		isNil(contextMenuLatLng) ||
		isNil(contextMenuLatLng.lat) ||
		isNil(contextMenuLatLng.lng)
	) {
		next({ name: "DeviceManager" });
		return;
	}
	next();
};

export default {
	path: "/DeviceManager",
	props: { pageTransition: "none" },
	meta: {
		breadcrumb: "Total Stations",
		authorizedRoles: [PERMISSIONS.TOTAL_STATION_VIEW]
	},
	component: PageViewer,
	children: [
		// {
		// 	path: "/DeviceManager/Devices",
		// 	name: "DeviceManager.Devices",
		// 	component: () =>
		// 		import(
		// 			/* webpackChunkName: "DeviceManager.Devices" */ "@/views/DeviceManager/Devices"
		// 		),
		// 	meta: {
		// 		authorizedRoles: [
		// 			PERMISSIONS.RSU_VIEW,
		// 			PERMISSIONS.TSC_VIEW,
		// 			PERMISSIONS.ESS_VIEW
		// 		]
		// 	},
		// 	children: [
		// 		{
		// 			path: "Manage/:deviceTypeId/:deviceId",
		// 			name: "DeviceManager.Manage",
		// 			component: () =>
		// 				import(
		// 					/* webpackChunkName: "DeviceManager.Manage" */ "@/views/DeviceManager/Manage"
		// 				)
		// 		}
		// 	]
		// },
		{
			path: "/DeviceManager/SpatVerification",
			name: "Spat Verification",
			component: () => import("@/views/DeviceManager/SpatVerification/Index"),
			meta: {
				breadcrumb: "Spat Verification",
				authorizedRoles: [PERMISSIONS.SPAT_VERIFY_VIEW]
			}
		},
		{
			path: "/",
			name: "DeviceManager",
			component: () =>
				import(
					/* webpackChunkName: "DeviceManager.Index" */ "@/views/DeviceManager/Index"
				),
			children: [
				{
					path: "SCR/:scrId?",
					name: "DeviceManager.TSSCR",
					beforeEnter: checkContextMenuLatLng,
					component: () =>
						import("@/views/ChangeRequests/TotalStationScrModal"),
					props: route => ({
						scrId: route.params.scrId && parseInt(route.params.scrId)
					}),
					meta: {
						authorizedRoles: [PERMISSIONS.TOTALSTATION_SCR_VIEW]
					}
				},
				{
					path: "DeviceSCR/:initialDeviceTypeId?/:scrId?",
					name: "DeviceManager.SCR",
					beforeEnter: checkContextMenuLatLng,
					component: () =>
						import(
							/* webpackChunkName: "DeviceManager.SCR" */ "@/views/ChangeRequests/DeviceScrModal"
						),
					meta: {
						authorizedRoles: [
							PERMISSIONS.SCR_RSU_VIEW,
							PERMISSIONS.SCR_TSC_VIEW,
							PERMISSIONS.SCR_ESS_VIEW,
							PERMISSIONS.RSU_LAB_TEST
						]
					},
					props: route => ({
						initialDeviceTypeId:
							route.params.initialDeviceTypeId &&
							parseInt(route.params.initialDeviceTypeId),
						scrId: route.params.scrId && parseInt(route.params.scrId),
						test: route.params.test
					})
				},
				{
					path: ":totalStationId",
					name: "DeviceManagerById"
				}
			]
		},
		DMS,
		RSU,
		Verification,
		ESS
	]
};
